import React from "react";
import PropTypes from "prop-types";

import "./style.css";

const VaporHorizontalStepper = ({
  currentStep,
  setCurrentStep,
  steps,
  readOnly, 
  style
}) => {
  function renderStep(item) {
    let classNameStep = "step";
    if (item.number === currentStep) {
      classNameStep = "step current";
    } else if (currentStep > item.number) {
      classNameStep = "step finished";
    }
    if (item.number < steps.length)
      classNameStep += " line";

    return (
      <React.Fragment key={"step_" + item.number}>
        <div className={classNameStep} id={item.number} style={style} 
          onClick={(e)=>{            
            if (steps.find(el => el.number === item.number).clickable){              
              setCurrentStep(item.number);
            }
          }}>
          <span className={`horizzontal-stepper--number ${!item.clickable && "not-clickable"}`}>{item.number}</span>
          <span className="horizzontal-stepper--title">{item.title}</span>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="vapor-horizontal-stepper">
      {steps?.map((item) => renderStep(item))}
    </div>
  );
};

VaporHorizontalStepper.propTypes = {
  currentStep: PropTypes.number,
  setCurrentStep: PropTypes.func,
  steps: PropTypes.array,
  readOnly: PropTypes.bool,
  style: PropTypes.object
};

VaporHorizontalStepper.defaultProps = {
  currentStep: 0,
  setCurrentStep: undefined,
  steps: [],
  readOnly: false,
  style: {}
};

export default VaporHorizontalStepper;
